import { render, staticRenderFns } from "./MessageLists.vue?vue&type=template&id=152b526d&lang=true&"
import script from "./MessageLists.vue?vue&type=script&lang=js&"
export * from "./MessageLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports